import React, { useState } from 'react';
import { 
  Box, 
  Card, 
  CardContent
} from '@mui/material';
import {
  AssignmentOutlined,
  HealthAndSafetyOutlined,
  CloudUploadOutlined
} from '@mui/icons-material';
import FileUploadDialog from '../ui/FileUploadDialog';
import MedicalFileDialog from '../ui/MedicalFileDialog';
import HospitalsDialog from '../ui/HospitalsDialog';
import { useFileContext } from '../../contexts/FileContext';

const ICON_TRANSPARENCY = 0.70;
const ICON_FILL_PERCENT = '80%';

const ServiceCard = ({ icon, title, onClick }) => (
  <Card
    aria-label={title}
    sx={{
      width: '100%',
      maxWidth: '85%',
      aspectRatio: '1 / 1',
      justifySelf: 'center',
      position: 'relative',
      overflow: 'visible',
      isolation: 'isolate',
      background: 'rgba(6, 18, 40, 0.35)',
      border: 'none',
      borderRadius: '8px',
      boxShadow: '0 10px 22px rgba(0,26,72,0.3), 0 0 2px rgba(35,151,241,0.3)',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      '&::before': {
        content: '""',
        position: 'absolute',
        inset: '-2px',
        borderRadius: '11px',
        zIndex: -1,
        pointerEvents: 'none',
        boxShadow: '0 0 10px rgba(44,173,255,0.45), 0 0 9px rgba(32,137,230,0.32)',
        opacity: 0.95,
      },
      '&:hover': {
        background: 'rgba(50, 175, 252, 0.08)',
        boxShadow: '0 2px 16px rgba(0,33,80,0.34), 0 0 18px rgba(48,184,255,0.45)',
        '&::before': {
          boxShadow: '0 0 6px rgba(64,190,255,0.65), 0 0 14px rgba(40,155,240,0.45)',
          opacity: 1,
        },
      },
    }}
    onClick={onClick}
  >
    <CardContent sx={{ 
      p: '0 !important',
      '&:last-child': { pb: '0 !important' },
      height: '100%',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}>
        <Box
          sx={{
            color: '#7fc6f5',
            width: ICON_FILL_PERCENT,
            height: ICON_FILL_PERCENT,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: ICON_TRANSPARENCY,
            '& .MuiSvgIcon-root, & svg': {
              width: '100%',
              height: '100%',
              fontSize: '100%',
            },
          }}
        >
          {icon}
        </Box>
      </Box>
    </CardContent>
  </Card>
);



export default function RightAnalytics({ pipecatService, emiratesId, patientName }) {
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [medicalFileDialogOpen, setMedicalFileDialogOpen] = useState(false);
  const [hospitalsDialogOpen, setHospitalsDialogOpen] = useState(false);
  const { addUploadedFile } = useFileContext();

  const handleServiceClick = (service) => {
    console.log(`Clicked on ${service}`);
    if (service === 'Upload File') {
      setUploadDialogOpen(true);
    } else if (service === 'Medical File') {
      setMedicalFileDialogOpen(true);
    } else if (service === 'Hospitals') {
      setHospitalsDialogOpen(true);
    } else {
      // Add navigation logic here for other services
    }
  };

  const handleUploadSuccess = (fileInfo) => {
    console.log('File uploaded successfully:', fileInfo);
    addUploadedFile(fileInfo);
    
    // Notify bot via RTVI if connected
    if (pipecatService && pipecatService.isConnectedToBot()) {
      const success = pipecatService.sendFileUploadNotification(fileInfo);
      if (success) {
        console.log('✅ Bot notified of file upload via RTVI');
      } else {
        console.warn('⚠️ Failed to notify bot of file upload');
      }
    } else {
      console.warn('⚠️ Bot not connected, file upload notification not sent');
    }
  };

  return (
    <>
      <Box sx={{ 
        display: "grid", 
        width: '100%',
        maxWidth: '100%',
        flexDirection: "column", 
        p: { xs: 0, sm: 0.75, md: 1.5 }, 
        gap: { xs: '8px', sm: '10px', md: '14px' },
        height: "100%",
        overflow: 'visible',
        alignItems: 'center',
        alignContent: 'center',
        gridTemplateColumns: { 
          xs: 'repeat(3, minmax(0, 1fr))',
          sm: 'repeat(3, minmax(0, 1fr))',
          md: 'repeat(3, minmax(0, 1fr))'
        }
      }}>
     

      {/* View Medical File */}
      <ServiceCard
        icon={
          <AssignmentOutlined
            sx={{
              color: '#7fc6f5',
              filter: 'drop-shadow(0 0 5px rgba(96, 196, 255, 0.35))',
              opacity: ICON_TRANSPARENCY,
            }}
          />
        }
        title="Medical File"
        onClick={() => handleServiceClick('Medical File')}
      />

      {/* Hospitals */}
      <ServiceCard
        icon={
          <HealthAndSafetyOutlined
            sx={{
              color: '#7fc6f5',
              filter: 'drop-shadow(0 0 5px rgba(96, 196, 255, 0.35))',
              opacity: ICON_TRANSPARENCY,
            }}
          />
        }
        title="Hospitals"
        onClick={() => handleServiceClick('Hospitals')}
      />
      
      {/* Upload File */}
      <ServiceCard
        icon={
          <CloudUploadOutlined
            sx={{
              color: '#7fc6f5',
              filter: 'drop-shadow(0 0 5px rgba(96, 196, 255, 0.35))',
              opacity: ICON_TRANSPARENCY,
            }}
          />
        }
        title="Upload File"
        onClick={() => handleServiceClick('Upload File')}
      />

{/* <ServiceCard
        icon={<LocalHospital />}
        title="View Your Medical Profile"
        subtitle="Medical Profile "
       
         onClick={() => handleServiceClick('"Medical Profile')}
        color="#7C4DFF"
      /> */}

      </Box>
      
      <FileUploadDialog
        open={uploadDialogOpen}
        onClose={() => setUploadDialogOpen(false)}
        onUploadSuccess={handleUploadSuccess}
      />
      
      <MedicalFileDialog
        open={medicalFileDialogOpen}
        onClose={() => setMedicalFileDialogOpen(false)}
        emiratesId={emiratesId}
        patientName={patientName}
      />
      
      <HospitalsDialog
        open={hospitalsDialogOpen}
        onClose={() => setHospitalsDialogOpen(false)}
      />
    </>
  );
}
